module.exports = __webpack_public_path__ + "static/img/title-test-1.a5bfb99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report/title-test-1.png
// module id = WsWc
// module chunks = 1